/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMasterDataTtlGeneration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMasterDataTtlGeneration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMasterDataTtlGeneration>): BackgroundJobPayloadForPeriodicMasterDataTtlGeneration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMasterDataTtlGeneration(), model);
        BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMasterDataTtlGeneration>): BackgroundJobPayloadForPeriodicMasterDataTtlGeneration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.newInstance(<BackgroundJobPayloadForPeriodicMasterDataTtlGeneration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMasterDataTtlGeneration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMasterDataTtlGeneration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
